var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 12 1.77778-1.7778m0 0 6.22222-6.2222 6.2222 6.2222m-12.44442 0v8.8889c0 .2358.09365.4619.26035.6286s.39279.2603.62854.2603h2.66666m8.88887-9.7778 1.7778 1.7778m-1.7778-1.7778v8.8889c0 .2358-.0936.4619-.2603.6286s-.3928.2603-.6286.2603h-2.6666m-5.33337 0c.23575 0 .46184-.0936.62854-.2603.16673-.1667.26033-.3928.26033-.6286v-3.5555c0-.2358.0937-.4619.2604-.6286s.3928-.2603.6285-.2603h1.7778c.2357 0 .4618.0936.6285.2603s.2604.3928.2604.6286v3.5555c0 .2358.0936.4619.2603.6286s.3928.2603.6286.2603m-5.33337 0h5.33337",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f686fa8243d7c1101bb96d5eb77548f1.svg";
export { ForwardRef as ReactComponent };